// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&family=Josefin+Sans:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --gold: #C8860A;
  --gold-dark: #8B5E0A;
  --gold-light: #E8A020;
  --orange: #C4480A;
  --orange-light: #E05A1A;
  --green: #4A6E2A;
  --green-light: #6A8E4A;
  --cream: #FDF6EC;
  --cream-dark: #F5E8D0;
  --brown: #5C3A0A;
  --text-dark: #2C1A06;
  --text-mid: #5C3A1A;
  --text-light: #8B6A3A;
  --white: #FFFFFF;
  --shadow: 0 4px 20px rgba(200, 134, 10, 0.15);
  --shadow-hover: 0 8px 32px rgba(200, 134, 10, 0.3);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Poppins', sans-serif;
  background-color: var(--cream);
  color: var(--text-dark);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
}

h1, h2, h3, h4 {
  font-family: 'Josefin Sans', sans-serif;
  color: var(--gold-dark);
}

a {
  text-decoration: none;
  color: inherit;
}

img {
  max-width: 100%;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-header {
  text-align: center;
  margin-bottom: 56px;
}

.section-header h2 {
  font-size: 2.4rem;
  color: var(--gold-dark);
  margin-bottom: 12px;
}

.section-header p {
  color: var(--text-mid);
  font-size: 1.05rem;
  max-width: 600px;
  margin: 0 auto;
}

.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 12px auto 16px;
}

.divider-line {
  width: 60px;
  height: 2px;
  background: linear-gradient(to right, transparent, var(--gold));
}

.divider-line.right {
  background: linear-gradient(to left, transparent, var(--gold));
}

.divider-icon {
  color: var(--gold);
  font-size: 1.2rem;
}

.btn-primary {
  background: linear-gradient(135deg, var(--gold), var(--orange));
  color: var(--white);
  border: none;
  padding: 14px 32px;
  border-radius: 50px;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: var(--shadow);
  display: inline-block;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-hover);
}

.btn-outline {
  background: transparent;
  color: var(--gold);
  border: 2px solid var(--gold);
  padding: 12px 32px;
  border-radius: 50px;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-block;
}

.btn-outline:hover {
  background: var(--gold);
  color: var(--white);
  transform: translateY(-2px);
}

.badge {
  display: inline-block;
  background: linear-gradient(135deg, var(--gold-light), var(--gold));
  color: var(--white);
  padding: 4px 16px;
  border-radius: 50px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 16px;
}

section {
  padding: 80px 0;
}

.card {
  background: var(--white);
  border-radius: 16px;
  padding: 32px;
  box-shadow: var(--shadow);
  transition: all 0.3s ease;
  border: 1px solid rgba(200, 134, 10, 0.1);
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-hover);
}

@media (max-width: 768px) {
  .section-header h2 {
    font-size: 1.8rem;
  }
  section {
    padding: 60px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;EAC7C,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+DAA+D;AACjE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,+DAA+D;EAC/D,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,mEAAmE;EACnE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&family=Josefin+Sans:wght@400;600;700&display=swap');\n\n:root {\n  --gold: #C8860A;\n  --gold-dark: #8B5E0A;\n  --gold-light: #E8A020;\n  --orange: #C4480A;\n  --orange-light: #E05A1A;\n  --green: #4A6E2A;\n  --green-light: #6A8E4A;\n  --cream: #FDF6EC;\n  --cream-dark: #F5E8D0;\n  --brown: #5C3A0A;\n  --text-dark: #2C1A06;\n  --text-mid: #5C3A1A;\n  --text-light: #8B6A3A;\n  --white: #FFFFFF;\n  --shadow: 0 4px 20px rgba(200, 134, 10, 0.15);\n  --shadow-hover: 0 8px 32px rgba(200, 134, 10, 0.3);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: 'Poppins', sans-serif;\n  background-color: var(--cream);\n  color: var(--text-dark);\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n}\n\nh1, h2, h3, h4 {\n  font-family: 'Josefin Sans', sans-serif;\n  color: var(--gold-dark);\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nimg {\n  max-width: 100%;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 56px;\n}\n\n.section-header h2 {\n  font-size: 2.4rem;\n  color: var(--gold-dark);\n  margin-bottom: 12px;\n}\n\n.section-header p {\n  color: var(--text-mid);\n  font-size: 1.05rem;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.divider {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin: 12px auto 16px;\n}\n\n.divider-line {\n  width: 60px;\n  height: 2px;\n  background: linear-gradient(to right, transparent, var(--gold));\n}\n\n.divider-line.right {\n  background: linear-gradient(to left, transparent, var(--gold));\n}\n\n.divider-icon {\n  color: var(--gold);\n  font-size: 1.2rem;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, var(--gold), var(--orange));\n  color: var(--white);\n  border: none;\n  padding: 14px 32px;\n  border-radius: 50px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow);\n  display: inline-block;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-hover);\n}\n\n.btn-outline {\n  background: transparent;\n  color: var(--gold);\n  border: 2px solid var(--gold);\n  padding: 12px 32px;\n  border-radius: 50px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-block;\n}\n\n.btn-outline:hover {\n  background: var(--gold);\n  color: var(--white);\n  transform: translateY(-2px);\n}\n\n.badge {\n  display: inline-block;\n  background: linear-gradient(135deg, var(--gold-light), var(--gold));\n  color: var(--white);\n  padding: 4px 16px;\n  border-radius: 50px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  margin-bottom: 16px;\n}\n\nsection {\n  padding: 80px 0;\n}\n\n.card {\n  background: var(--white);\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: var(--shadow);\n  transition: all 0.3s ease;\n  border: 1px solid rgba(200, 134, 10, 0.1);\n}\n\n.card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-hover);\n}\n\n@media (max-width: 768px) {\n  .section-header h2 {\n    font-size: 1.8rem;\n  }\n  section {\n    padding: 60px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
